// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".asset-preview[data-v-55279b64]{border:2px solid #fff;border-radius:.35rem}", ""]);
// Exports
module.exports = exports;
